module.exports = __webpack_public_path__ + "static/media/Estampa_Card1.f4fd6315.png";